module.exports = __webpack_public_path__ + "static/media/payment-error.af8dad7a.png";